export function canUseAction(action, unit) {
  if (!action || !unit) return false;

  const cost = action.energy_cost || 0;
  const apCost = action.ap_cost || 0;

  const hasEnoughEnergy = unit.energy >= cost;
  const hasEnoughAP = unit.ap >= apCost;

  // También puedes añadir validaciones especiales por tipo
  // e.g. si la acción está en cooldown, si requiere objetivo, etc.

  return hasEnoughEnergy && hasEnoughAP;
}
